import { Injectable } from '@angular/core';
import { MainMenu, MenuAdmin } from 'app/shared/models/class/menu/menu';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  /* ------------------------------- Admin menu ------------------------------- */

  /* -------------------------------------------------------------------------- */

  menu: MenuAdmin[] = [
    {
      name: 'Les offres',
      description: 'Gérer l\'ensemble des offres',
      icon: 'faStore',
      iconLabel: 'faStore',
      url: '/admin/offers',
      iconType: 'faicon',
      role: ['admin']
    },
    {
      name: 'Les clubs',
      description: 'Gérer l\'ensemble des clubs',
      icon: '/assets/img/clubs.svg',
      iconLabel: '/assets/img/clubs.svg',
      url: '/admin/clubs',
      iconType: 'club',
      role: ['admin']
    },
    {
      name: 'Les structures',
      description: 'Gérer l\'ensemble des structures',
      icon: 'faSitemap',
      iconLabel: 'faSitemap',
      url: '/admin/structure',
      iconType: 'faicon',
      role: ['admin']
    },
    {
      name: 'Tableau de bord du club',
      description: 'Éditer les infos de mon club',
      icon: '/assets/img/clubs.svg',
      iconLabel: '/assets/img/clubs.svg',
      url: '/admin/my-club',
      iconType: 'club',
      role: ['club']
    },
    {
      name: 'Guichet',
      description: 'Afficher le guichet virtuel du club',
      icon: 'faCashRegister',
      iconLabel: 'faCashRegister',
      url: '/admin/counter',
      iconType: 'faicon',
      role: ['club', 'admin', 'counter']
    },
    {
      name: 'Planification',
      description: 'Gérer la planification des sessions',
      icon: 'faCalendarAlt',
      iconLabel: 'faCalendarAlt',
      url: '/admin/planning',
      iconType: 'faicon',
      role: ['club', 'admin', 'planning']
    },
    {
      name: 'Paiements',
      description: 'Gérer les paiements du site',
      icon: 'faCreditCard',
      iconLabel: 'faCreditCard',
      url: '/admin/payments',
      iconType: 'faicon',
      role: ['club', 'admin']
    },
    {
      name: 'Lieux de pratiques',
      description: 'Gérer les lieux de pratique de mon club',
      icon: 'faMapMarkerAlt',
      iconLabel: 'faMapMarkerAlt',
      url: '/admin/practice-place',
      iconType: 'faicon',
      role: ['club', 'admin']
    },
    {
      name: 'Priorités des offres',
      description: 'Gérer la priorité des offres du club',
      icon: 'faStar',
      iconLabel: 'faStar',
      url: '/admin/offer-priority',
      iconType: 'faicon',
      role: ['club', 'admin']
    },
    {
      name: 'Code Promo',
      description: 'Gérer les codes promo du club',
      icon: 'faPercentage',
      iconLabel: 'faTags',
      url: '/admin/discount',
      iconType: 'faicon',
      role: ['club', 'admin']
    },
    {
      name: 'Ressources du club',
      description: 'Gérer les ressources moniteur du club',
      icon: 'faUsers',
      iconLabel: 'faUsers',
      url: '/admin/resource',
      iconType: 'faicon',
      role: ['club', 'admin']
    },
    {
      name: 'Tags',
      description: 'Gérer les tags des offres',
      icon: 'faTags',
      iconLabel: 'faTags',
      url: '/admin/tags',
      iconType: 'faicon',
      role: ['admin']
    },
    {
      name: 'Utilisations des ressources',
      description: 'Liste des ressources utilisées dans des sessions',
      icon: 'faTable',
      iconLabel: 'faTable',
      url: '/admin/used-ressources',
      iconType: 'faicon',
      role: ['admin', 'club']
    },
    {
      name: 'Réservations',
      description: 'Exporter les réservations en fichier Excel',
      icon: 'faFileExcel',
      iconLabel: 'faFileExcel',
      url: '/admin/',
      iconType: 'faicon',
      role: ['club']
    },
    {
      name: 'Liste des modifications',
      description: 'Historique des modifications sur les sessions',
      icon: 'faBookOpen',
      iconLabel: 'faBookOpen',
      url: '/admin/modifications',
      iconType: 'faicon',
      role: ['admin', 'club']
    },
    {
      name: 'Paramètres',
      description: 'Gérer les paramètres globaux',
      icon: 'faPen',
      iconLabel: 'faPen',
      url: '/admin/parameters',
      iconType: 'faicon',
      role: ['admin']
    },
    {
      name: 'Sessions',
      description: 'Recherche de sessions',
      icon: 'faListAlt',
      iconLabel: 'faListAlt',
      url: '/admin/sessions',
      iconType: 'faicon',
      role: ['admin', 'club']
    },
    {
      name: 'Fédérations',
      description: 'Fédérations et licences',
      icon: 'faPassport',
      iconLabel: 'faPassport',
      url: '/admin/federations',
      iconType: 'faicon',
      role: ['admin']
    },
    {
      name: 'Extractions',
      description: 'Extractions d\'excels des différentes tables',
      icon: 'faArrowAltCircleUp',
      iconLabel: 'faArrowAltCircleUp',
      url: '/admin/reports',
      iconType: 'faicon',
      role: ['admin']
    },
    {
      name: 'Aides vidéos',
      description: 'Gérer les aides vidéos',
      icon: 'faVideo',
      iconLabel: 'faVideo',
      url: '/admin/help',
      iconType: 'faicon',
      role: ['admin']
    }
  ];



  mainMenu: MainMenu[] = [
    {
      name: 'Trouvez une activité',
      url: '/home',
      faIcon: 'faSearch'
    },
    // {
    //   name: 'Mes favoris',
    //   url: '/home/my-wishes',
    //   faIcon: faHeart
    // },
    {
      name: 'Mes réservations',
      url: '/home/purchases-history',
      faIcon: 'faBookmark'
    },
    {
      name: 'Mon panier - Mes favoris',
      url: '/home/my-shopping-bag',
      faIcon: 'faShoppingBasket'
    }
  ];

  navSession: string[] = ['Toutes les sessions', 'Sessions du mois'];

  constructor() { }
}
